

/** Stable empty set, so the drag ref has a real Set before the first render. */
export const EMPTY_MARKED = new Set();

// ─── Persistence helpers ─────────────────────────────────────────────────────

export function loadSidebarState(workspaceId) {
  if (!workspaceId) return null;
  try {
    const raw = localStorage.getItem(`sidebar-state:${workspaceId}`);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveSidebarState(workspaceId, expandedCollections, expandedFolders) {
  if (!workspaceId) return;
  try {
    localStorage.setItem(
      `sidebar-state:${workspaceId}`,
      JSON.stringify({
        expandedCollections: [...expandedCollections],
        expandedFolders: [...expandedFolders],
      })
    );
  } catch {}
}

// ─── Row style constants ──────────────────────────────────────────────────────

export const SIDEBAR_TREE_ROW_IDLE =
  'border border-transparent hover:bg-gray-50 hover:border-gray-200';

export const SIDEBAR_TREE_ROW_ACTIVE = 'sidebar-tree-row-active border';

export const SIDEBAR_TREE_ROW_DROP = 'bg-blue-50 border border-blue-200';
